import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

import { getCookie } from '../../../utils/utility';

export const getSeverityInsights = createAsyncThunk(
  'getSeverityInsights',
  async (_, thunkAPI) => {
    const token = await getCookie('token');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_BACKEND_URL}/api/get-severity-insights`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data.data;
    } catch (err: any) {
      if (err.response && err.response.data && err.response.data.errors) {
        return thunkAPI.rejectWithValue(err.response.data.errors[0].message);
      }
      throw err;
    }
  },
);

export const getRestrictions = createAsyncThunk(
  'getRestrictions',
  async (_, thunkAPI) => {
    const token = await getCookie('token');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_BACKEND_URL}/api/get-restriction-count-per-day`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data.restriction_per_day;
    } catch (err: any) {
      if (err.response && err.response.data && err.response.data.errors) {
        return thunkAPI.rejectWithValue(err.response.data.errors[0].message);
      }
      throw err;
    }
  },
);

// show this in table
export const getMostRestrictedUsersData = createAsyncThunk(
  'getMostRestrictedUsersData',
  async (_, thunkAPI) => {
    const token = await getCookie('token');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_BACKEND_URL}/api/get-most-restricted-users`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data.data;
    } catch (err: any) {
      console.error('Error in getMostRestrictedUsersData:', err);
      if (err.response && err.response.data && err.response.data.error) {
        return thunkAPI.rejectWithValue(err.response.data.error);
      }
      throw err;
    }
  },
);

export const fetchRestrictionPerDay = createAsyncThunk(
  'restrictions/fetchRestrictionPerDay',
  async (_, thunkAPI) => {
    try {
      const state: any = thunkAPI.getState();
      const token = await getCookie('token');
      const apiType = state.auditingDashboard?.apiType || 'fields';

      const payload = {
        time: {
          start_time:
            state.auditingDashboard?.startTime || '2011-01-01 00:00:00',
          end_time: state.auditingDashboard?.endTime || '2025-12-31 23:59:59',
        },
        email: state.auditingDashboard?.emailAddresses || undefined,
        status: state.auditingDashboard?.statusArray || undefined,
        ip: state.auditingDashboard?.ipAddresses || undefined,
        fields: state.auditingDashboard?.fields || undefined,
        appAccessed: state.auditingDashboard?.appAccessed || undefined,
        group_by: ['status', 'appAccessed', 'casbApp'],
        casbApp: state.auditingDashboard?.casbApp || undefined,
        groupId: state.auditingDashboard?.groupId || undefined,
        macAddress: state.auditingDashboard?.macAddresses || undefined,
        limit: state.auditingDashboard?.limit || undefined,
        page: state.auditingDashboard?.page || undefined,
        query_type: apiType === 'count' ? 'count' : 'fields',
      };

      const filteredPayload = JSON.parse(
        JSON.stringify(payload, (key, value) => {
          if (value == null || (Array.isArray(value) && value.length === 0)) {
            return undefined;
          }
          return value;
        }),
      );
      const url = `${process.env.REACT_APP_NODE_BACKEND_URL}/api/get-restriction-data`;
      const response = await axios.post(url, filteredPayload, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      });
      return response.data.data;
    } catch (err: any) {
      if (err.response && err.response.data && err.response.data.error) {
        toast.error(err.response.data.error);
        return thunkAPI.rejectWithValue(err.response.data.error);
      }
      toast.error('Failed to fetch restriction data.');
      throw err;
    }
  },
);
